import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../contexts/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Добро пожаловать");
      navigate("/admin");
    } catch (e) {
      const detail = e?.response?.data?.detail || "Ошибка входа";
      setErr(typeof detail === "string" ? detail : "Ошибка входа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-midnight relative overflow-hidden flex items-center justify-center px-6">
      <div className="absolute inset-0 tech-grid-bg" />
      <div className="absolute -top-40 -right-32 w-[500px] h-[500px] rounded-full bg-coral/15 blur-3xl" />

      <div className="relative w-full max-w-md">
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] uppercase text-white/50 hover:text-coral mb-8"
        >
          <ArrowLeft size={14} /> Back to site
        </Link>

        <div className="bg-midnight-2 p-10 border border-white/10">
          <div className="overline mb-3">ADMIN · 管理</div>
          <h1 className="font-display font-extrabold tracking-tighter text-white text-3xl md:text-4xl mb-8 uppercase">
            Вход в админ-панель
          </h1>

          <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
            <div>
              <label className="overline mb-2 block">Логин</label>
              <input
                data-testid="admin-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="admin"
                className="w-full bg-midnight-3 border border-white/10 focus:border-coral px-4 py-3 text-white placeholder:text-white/30 outline-none font-display transition-colors"
              />
            </div>
            <div>
              <label className="overline mb-2 block">Пароль</label>
              <input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="w-full bg-midnight-3 border border-white/10 focus:border-coral px-4 py-3 text-white placeholder:text-white/30 outline-none font-display transition-colors"
              />
            </div>

            {err && (
              <div
                className="text-sm text-brand-red font-display"
                data-testid="admin-login-error"
              >
                {err}
              </div>
            )}

            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="btn-primary w-full justify-center !py-4 mt-4 disabled:opacity-50"
            >
              {loading ? (
                <>
                  <Loader2 size={16} className="animate-spin" /> Вход...
                </>
              ) : (
                <>
                  <Lock size={14} /> Войти
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
